<div class="bkgrey">
  <div class="container">
  <section class="mt-0 completeProfileloged">
        <div class="completeProfile"> 
              <h6 class="heading-6">Complete Profile</h6> 
              <div class="completeProfilecontent">
                <div class="profile-upload ">
                  <div class="proEdit">
                      <input type="file" accept=".png, .jpg, .jpeg">
                      <label id="imageUpload"><i class="ic_profile_edit"><img src="assets/images/ic_profile_edit.svg"></i></label>
                  </div>
                  <div class="avatar-preview">
                      <div id="imagePreview">
                          <img [src]="profileImage" alt="profile">
                      </div>
                    
                  </div>
                </div>  
                  <h4>{{allData?.name || "-"}}</h4>
                  <p>{{allData?.address || "-"}}, {{allData?.city || "-"}}, {{allData?.location || "-"}} - {{allData?.zipCode || "-"}}</p>
                  <p class="orange">{{allData?.email || "-"}}</p>
              </div>
              <h6 class="heading-6">About</h6> 
              <p class="para6">{{allData?.description || "-"}}</p>
              <h6 class="heading-6">Company Size</h6> 
              <p>{{allData?.companySize || "-"}}</p> 
              <h6 class="heading-6">Industry</h6>
              <p>{{allData?.industry || "-"}}</p>
              <h6 class="heading-6">Company Detail</h6> 
              <div class="row ">
                <div class="col-sm-3 companydetail">
                  <img src="assets/images/account.svg">
                  <div class="content">
                    <p>Primary contact</p>
                    <h5>{{allData?.companyName}}</h5>
                  </div>
                </div>
                <div class="col-sm-3 companydetail">
                  <img src="assets/images/ic_phone.svg">
                  <div class="content">
                    <p>Phone number</p>
                    <h5>{{allData?.countryCode}}{{allData?.phoneNumber || "-"}}</h5>
                  </div>
                </div>
                <div class="col-sm-3 companydetail">
                  <img src="assets/images/ic_email.svg">
                  <div class="content">
                    <p>Email</p>
                    <h5>{{allData?.companyEmail || "-"}}</h5>
                  </div>
                </div>
                <div class="col-sm-3 companydetail">
                  <img src="assets/images/linkedin.svg">
                  <div class="content">
                    <p>Linkedin</p>
                    <h5>{{allData?.linkedInLink || "-"}}</h5>
                  </div>
                </div>
              </div>
      </div>        
    </section>
  </div>
</div> 
<!-- End -->